import { render, staticRenderFns } from "./DdsCreateTable.vue?vue&type=template&id=67078d60&"
import script from "./DdsCreateTable.vue?vue&type=script&lang=js&"
export * from "./DdsCreateTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports